exports.isWindows = () => {
  const agent = navigator.userAgent.toLowerCase();
  return /windows|win32/.test(agent);
};

exports.assignAllProp = (self, propArray, from) => {
  for (const item of propArray) {
    self[item.prop] = from[item.prop] !== undefined ? from[item.prop] : item.defaultValue;
  }
};

exports.getRightSelectedControl = (state) => {
  return state.page.selectedControls[0];
};

exports.getEditTypeOfPageId = (state, pageId) => {
  return 'page';
};

function _getRightSelectControls (state) {
  return state.page.selectedControls;
}

exports.getRightSelectControls = (state) => {
  return _getRightSelectControls(state);
};

exports.showSetting = (state) => {
  return _getRightSelectControls(state).length == 1;
};

exports.showManySetting = (state) => {
  return _getRightSelectControls(state).length > 1;
}

exports.getRightCurrentPageWithType = (app, editType) => {
  return app.currentPage;
};

exports.getPageEditFlag = (state, editType) => {
  return state.page.modify;
};

// todo: try to merge same fuction
// exports.getRightCurrentPage = (state) => {
//   // return getRightCurrentPageWithType(state, state.app.editType);
//   return state.page.pageInfo;
// };

exports.getRightControlsWithType = (state, editType) => {
  return state.page.controls;
};

exports.getRightControls = (state) => {
  // return getRightControlsWithType(state, state.app.editType);
  return state.page.controls;
};


// 我觉得是一样的 todo 青青去check
exports.getRightControlsMap = (state) => {
  return state.page.controlsMap;
};

exports.getDatasourceForms = (controlProp, tables, pages) => {
  let allForms = [];
  if (controlProp.tables && controlProp.tables.length) {
    for (let i = 0; i < controlProp.tables.length; i++) {
      let item = controlProp.tables[i];
      if (item.type && item.type === 'table') {
        // 获取对应table信息
        const table = tables.find(table => {
          return table.table_id === item.form;
        });
        if (table) {
          allForms.push({
            'formName': table.table_name,
            'table_id': table.table_id,
            'type': 'table',
          });
        }
      } else {
        // 获取对应page信息
        let page = pages.find(page => {
          return page.page_id === item.form;
        });
        if (page) {
          allForms.push({
            'formName': (page.type == 1 && page.extra && page.extra.tableName) ? page.extra.tableName : '未设定',
            'page_id': page.page_id,
            'type': 'page',
          });
        }
      }
    }
  }
  return allForms;
};

// tables : all database define tables
// pages: all pages
// controlDefinesMap
// formId: pageId or formTable id
// type: 'formPage' for pages, table for tables
exports.getBindFields = (tables, pages, controlDefinesMap, formId, type = 'formPage') => {
  // 获取绑定的Form表单绑定字段
  const fields = [];
  const must = new Set(['hex_create_time', 'hex_update_time']);
  const map = { hex_create_time: '系统创建时间', hex_update_time: '系统修改时间' };

  if (type === 'table') {
    // 获取对应table信息
    const table = tables.find(table => table.table_id === formId);
    if (table && table.fields) {
      table.fields.forEach(item => {
        if (must.has(item.field_name)) {
          must.delete(item.field_name);
        }
        let field = {
          'field': item.field_name,
          'name': item.name,
          'selected': true,
          'formName': table.table_name,
          'table_id': table.table_id,
        };
        fields.push(field);
      })
      fields.unshift({
        'field': '_id',
        'name': '主键',
        'formName': table.table_name,
        'page_id': table.table_id,
      });
    }
  } else {
    // 获取对应page信息
    const page = pages.find(page => page.page_id === formId);
    // 递归查找 form control
    let findFormControls = (controls) => {
      controls.forEach(control => {
        let define = controlDefinesMap[control.type];
        if (define.isForm) {
          for (let key in define.props) {
            let propDefine = define.props[key];
            if (propDefine.isFormFieldSetting && control.props && control.props[key]) {
              const fieldName = control.props[key];
              const field = {
                'type': control.type,
                'field': fieldName,
                'name': control.props['formName'],
                'props': control.props,
                'selected': true,
                'formName': (page.type == 1 && page.extra && page.extra.tableName) ? page.extra.tableName : '未设定',
                'page_id': page.page_id,
              };
              if (must.has(fieldName)) {
                must.delete(fieldName);
              }
              fields.push(field);
            } // end if
          } // end for
        } // end if
        if (control.children) {
          findFormControls(control.children);
        }
      }) // end forEach
    };
    if (page && page.controls) {
      findFormControls(page.controls);
      fields.push({
        'field': '_id',
        'name': '主键',
        'formName': (page.type == 1 && page.extra && page.extra.tableName) ? page.extra.tableName : '未设定',
        'page_id': page.page_id,
      });
    }
  }

  if (fields.length) {
    for (const name of must) {
      fields.push({ 'field': name, 'name': map[name], 'formName': map[name] })
    }
  }

  return fields;
};

exports.revertCamelToString = function (str) {
  let ans = '';
  for (let i = 0; i < str.length; i += 1) {
    const ch = str[i];
    if (ch >= 'A' && ch <= 'Z') {
      ans += `-${ch.toLowerCase()}`;
    } else {
      ans += ch;
    }
  }
  return ans;
}
exports.findOneMatch = (control, id) => {
  const matchResult = [];
  const propsString = JSON.stringify(control.props);
  if (propsString.indexOf(id) !== -1) {
    matchResult.push("props");
  }
  if (control.events) {
    const eventsString = JSON.stringify(control.events);
    if (eventsString.indexOf(id) !== -1) {
      matchResult.push("events");
    }
  }

  if (control.type === "flow") {
    const allFlows = control.options;
    for (const flow of allFlows) {
      const flowString = JSON.stringify(flow);
      if (flowString.indexOf(id) !== -1) {
        matchResult.push("flow" + flow.id);
      }
    }
  }
  return matchResult;
};

function arrayToMaps (arr, key) {
  if (!Array.isArray(arr)) return {};
  return arr.reduce((last, cur) => {
    if (cur[key]) last[cur[key]] = cur;
    return last;
  }, {});
}

function appendZero (num) {
  return num < 10 && num >= 0 ? `0${num}` : num
}

exports.formatTime = (date, isZero) => {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  let y = date.getFullYear()
  let M = appendZero(date.getMonth() + 1)
  let D = appendZero(date.getDate())
  let W = appendZero(date.getDay())
  let H = appendZero(date.getHours())
  let m = appendZero(date.getMinutes())
  let s = appendZero(date.getSeconds())
  let ms = appendZero(date.getMilliseconds())

  return `${y}-${M}-${D} ${H}:${m}:${s}`
}

exports.checkControlBind = (flows, controls) => {
  let bindFlows = [];
  let map = {};

  const walkThrowControlTree = (ctrls) => {
    ctrls.map(ctrl => {
      // check if this ctrl bind flows
      const ctrlPropStr = JSON.stringify(ctrl.props);
      flows.map(flow => {
        if (ctrlPropStr.indexOf(flow.flow_id) !== -1 && !map[`${ctrl.controlId}${flow.flow_id}`]) {
          map[`${ctrl.controlId}${flow.flow_id}`] = true;
          bindFlows.push({
            controlId: `${ctrl.controlId}[${ctrl.name}]`,
            flowId: `${flow.flow_id}[${flow.name}]`,
            optionId: ''
          });
        }
      });

      // check if one flows bind this ctrl
      flows.map(flow => {
        // check all options
        flow.options.map(option => {
          const optionStr = JSON.stringify(option);
          if (optionStr.indexOf(ctrl.controlId) > -1 && !map[`${ctrl.controlId}${flow.flow_id}`]) {
            map[`${ctrl.controlId}${flow.flow_id}`] = true;
            bindFlows.push({
              controlId: `${ctrl.controlId}[${ctrl.name}]`,
              flowId: `${flow.flow_id}[${flow.name}]`,
              optionId: option.id
            });
          }
        });
      });

      // check my children
      if (Array.isArray(ctrl.children)) {
        walkThrowControlTree(ctrl.children);
      }
    });
  }

  walkThrowControlTree(controls);

  return bindFlows;
}

const unit = [
  "width",
  "height",
  "line-height",
  "border-radius",
  "font-size",
  "margin",
  "padding",
  "border-width",
  "border-left-width",
  "border-right-width",
  "border-top-width",
  "border-bottom-width",
  "padding-left",
  "padding-right",
  "padding-top",
  "padding-bottom",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-bottom",
  'top',
  'left',
  'letter-spacing'
]
function colorRGB2Hex (color) {
  var rgb = color.split(',');
  var r = parseInt(rgb[0].split('(')[1]);
  var g = parseInt(rgb[1]);
  var b = parseInt(rgb[2].split(')')[0]);

  var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  return hex;
}
const fixPlurals = (style, k) => {
  const directs = ['top', 'left', 'right', 'bottom']
  directs.forEach((direct, index, A) => {
    if (k === 'margin' || k === 'padding') {
      style[`${k}-${direct}`] = parseFloat(style[k])
    } else if (k === 'border' && style[k]) {
      const [width, s, color] = style[k].toString().split(/\s+/g)
      if (width) {
        style[`${k}-${direct}-width`] = parseFloat(width)
      }
      if (style && index === 0) {
        style[`${k}-style`] = s
      }
      if (color && index === 0) {
        style[`${k}-color`] = color
      }
    }
  })
  if (k === 'border-radius') {
    ['top-left', 'top-right', 'bottom-left', 'bottom-right'].forEach((kk, index, A) => {
      style[`border-${kk}-radius`] = parseFloat(style[k])
    })
    delete style[k]
  }
  if (k === 'background') {
    style['background-color'] = style[k]
  }
  return style
}
function toUpperCase (k) {
  return k.replace(/\-(\w)/g, ($0, $1) => $1.toUpperCase())
}
function transformEditorStyle (style) {
  let k
  for (k in style) {
    if (unit.includes(k)) {
      style[k] = parseFloat(style[k])
    }
    style = fixPlurals(style, k)
  }
  // ['margin', 'padding', 'border-radius', 'border'].forEach(x => {
  //   if (x in style) delete style[x]
  // })
  for (k in style) {
    if (/\-(\w)/g.test(k)) {
      style[toUpperCase(k)] = style[k]
      delete style[k]
    }
  }
  return style
}

exports.pasteStyle = function (t) {
  let s = {}
  try {
    t = `.a{${t}}`
    console.log(t)
    let ast = cssparser.parse(t)
    let json = ast.toJSON('simple')
    s = transformEditorStyle(json.value[0].declarations)
    console.log('result', s)
  } catch (e) {
    console.error('css错误', e)
    s = {}
  }
  return s
}



exports.arrayToMaps = arrayToMaps



// WEBPACK FOOTER //
// ./src/utils/utils.js